/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Sample booking data structure
// In a real application, this would come from an API

export const statusColors = {
  confirmed: "#2e7d32", // green
  pending: "#ed6c02", // orange
  cancelled: "#d32f2f", // red
};

export const statusLabels = {
  confirmed: "Confirmed",
  pending: "Pending",
  cancelled: "Cancelled",
};

// Generate sample bookings for the calendar
export const generateSampleBookings = () => {
  const today = new Date();
  const bookings = [];

  // Generate bookings for the next 60 days
  for (let i = 0; i < 15; i++) {
    const startDate = new Date(today);
    startDate.setDate(today.getDate() + Math.floor(Math.random() * 60));
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + Math.floor(Math.random() * 7) + 1);

    const statuses = ["confirmed", "pending", "cancelled"];
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const properties = [
      { id: "1", name: "Luxury Beach Villa" },
      { id: "2", name: "Downtown Apartment" },
      { id: "3", name: "Mountain Cabin" },
      { id: "4", name: "City Loft" },
      { id: "5", name: "Country House" },
    ];
    const property = properties[Math.floor(Math.random() * properties.length)];
    const guests = [
      "John Smith",
      "Emily Johnson",
      "Michael Brown",
      "Sarah Davis",
      "David Wilson",
      "Jennifer Martinez",
      "Robert Taylor",
      "Jessica Anderson",
    ];
    const guestName = guests[Math.floor(Math.random() * guests.length)];
    const paymentTotal = (Math.random() * 5000 + 100).toFixed(2);

    bookings.push({
      id: `booking-${i + 1}`,
      title: `${property.name} - ${guestName}`,
      start: startDate,
      end: endDate,
      resource: {
        id: `booking-${i + 1}`,
        guestName,
        propertyId: property.id,
        propertyName: property.name,
        status,
        paymentTotal: parseFloat(paymentTotal),
        startDate,
        endDate,
        bookingId: `BK-${1000 + i}`,
        contactEmail: `${guestName.toLowerCase().replace(" ", ".")}@example.com`,
        contactPhone: `+1-555-${Math.floor(Math.random() * 10000)
          .toString()
          .padStart(4, "0")}`,
      },
    });
  }

  return bookings;
};

export default generateSampleBookings;
